import { Share2, Facebook, Mail, Link2, Radio, Film, MousePointerClick } from "lucide-react";

const SOURCES = [
  { key: "facebook", label: "Facebook", icon: Facebook, color: "#1877F2" },
  { key: "x", label: "X", icon: null, color: "#e5e7eb" },
  { key: "email", label: "Email", icon: Mail, color: "#34D399" },
  { key: "link", label: "Copied link", icon: Link2, color: "#F59E0B" },
];

const XMark = () => <span className="font-bold text-[13px] leading-none">𝕏</span>;

function SourceTile({ src, views, clicks }) {
  const Icon = src.icon;
  return (
    <div data-testid={`share-source-${src.key}`} className="rounded-xl border border-gray-800 bg-gray-950 p-4">
      <div className="flex items-center gap-2 text-sm text-gray-300">
        <span className="h-7 w-7 rounded-lg flex items-center justify-center bg-gray-900 border border-gray-800" style={{ color: src.color }}>{Icon ? <Icon className="h-4 w-4" /> : <XMark />}</span>
        {src.label}
      </div>
      <p className="mt-3 text-2xl font-display font-bold text-white" data-testid={`share-source-${src.key}-views`}>{views}</p>
      <p className="text-[11px] text-gray-500">views from shared links</p>
      <p className="mt-2 text-xs text-gray-400 inline-flex items-center gap-1" data-testid={`share-source-${src.key}-clicks`}><MousePointerClick className="h-3.5 w-3.5" /> {clicks} share clicks</p>
    </div>
  );
}

export function SharedLinks({ data }) {
  const tv = data?.totals?.views || {};
  const tc = data?.totals?.clicks || {};
  const items = data?.items || [];
  return (
    <div data-testid="shared-links-section" className="bg-card border border-gray-800 rounded-2xl overflow-hidden mt-6">
      <div className="px-5 py-4 border-b border-gray-800 flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-display text-base font-semibold flex items-center gap-2"><Share2 className="h-4 w-4 text-amber-400" /> Shared Links</h3>
        <p className="text-xs text-gray-500"><span data-testid="share-total-views" className="text-white font-semibold">{tv.total || 0}</span> views · <span data-testid="share-total-clicks" className="text-white font-semibold">{tc.total || 0}</span> share clicks · each viewer counted once per video per day</p>
      </div>
      <div className="p-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {SOURCES.map((s) => <SourceTile key={s.key} src={s} views={tv[s.key] || 0} clicks={tc[s.key] || 0} />)}
      </div>
      <div className="overflow-x-auto border-t border-gray-800">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-gray-500 text-xs uppercase tracking-wide">
            <th className="px-5 py-3 font-medium">Video / stream</th>
            {SOURCES.map((s) => <th key={s.key} className="px-4 py-3 font-medium text-right">{s.label}</th>)}
            <th className="px-5 py-3 font-medium text-right">Total views</th>
            <th className="px-5 py-3 font-medium text-right">Share clicks</th>
          </tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={7} className="px-5 py-10 text-center text-gray-500" data-testid="shared-links-empty">No shared-link activity in this period yet. Turn on sharing in your Player profile so viewers can share.</td></tr>
            ) : items.map((r) => (
              <tr key={r.kind + r.id} data-testid={`share-row-${r.id}`} className="border-t border-gray-800/70 hover:bg-gray-800/30">
                <td className="px-5 py-3 text-white font-medium">
                  <span className="inline-flex items-center gap-2">{r.kind === "live" ? <Radio className="h-3.5 w-3.5 text-red-400" /> : <Film className="h-3.5 w-3.5 text-amber-400" />}{r.title}</span>
                </td>
                {SOURCES.map((s) => (
                  <td key={s.key} className="px-4 py-3 text-right text-gray-300 tabular-nums" title={`${r.clicks[s.key]} share clicks`}>
                    {r.views[s.key]}{r.clicks[s.key] > 0 && <span className="text-[10px] text-gray-500 ml-1">({r.clicks[s.key]})</span>}
                  </td>
                ))}
                <td className="px-5 py-3 text-right text-white font-semibold tabular-nums">{r.total_views}</td>
                <td className="px-5 py-3 text-right text-gray-300 tabular-nums">{r.total_clicks}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length > 0 && <p className="px-5 py-2.5 text-[11px] text-gray-500 border-t border-gray-800/70">Numbers in brackets are share-button clicks for that network.</p>}
      </div>
    </div>
  );
}
